import { SearchResult } from './search.types';

/**
 * Resolves the click-through route for a global search hit.
 *
 * Several result types have no per-id route yet in `app.routes.ts` (agent, hyperform, tracker) -
 * those deliberately fall back to the feature's list page rather than inventing a detail route.
 * `table` hits are not independently routable either, so they land on the parent data source's
 * tables page using the `id` the backend already resolved to the parent (see `SearchResult`).
 */
export function resolveSearchResultLink(result: SearchResult): string[] {
    switch (result.type) {
        case 'data_source':
        case 'table':
            return ['/data-sources', String(result.id), 'tables'];
        case 'dashboard':
            return ['/dashboards', 'view', String(result.id)];
        case 'report':
            return ['/reports', 'report', String(result.id)];
        case 'task':
            return ['/tasks', String(result.id)];
        case 'agent':
            return ['/ai-agents'];
        case 'hyperform':
            return ['/hyper-forms'];
        case 'tracker':
            return ['/tracker'];
    }
}
